<div class="modal-body jobDialogBody section-container" style="padding: 0.1rem">
  <mat-accordion>
    <form [formGroup]="configForm">
      <!-- Basic Settings Panel -->
      <mat-expansion-panel class="custom-expansion" expanded="true">
        <mat-expansion-panel-header
          class="sticky-header border-bottom"
          style="height: 3rem; background-color: white"
        >
          <mat-panel-title style="color: var(--s-primary-color)">
            Basic Settings
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="expansion-content">
          <!-- Left Column -->
          <div class="left ps-0">
            <ng-container
              *ngFor="
                let section of getBasicSections();
                let i = index;
                trackBy: trackByParameter
              "
            >
              <div class="section" *ngIf="i < getBasicSections().length / 2">
                <div class="section-title">
                  <h2 id="basic-{{ section[0] | lowercase }}-heading">
                    {{ section[0] }}
                  </h2>
                </div>
                <div class="section-body">
                  <ng-container
                    *ngFor="let item of section[1]; trackBy: trackByParameter"
                  >
                    <div class="body">
                      <label [for]="'basic-' + item.parameterName">
                        {{ getDisplayName(item.parameterName) }}
                      </label>

                      <div class="input-container">
                        <!-- Text Input -->
                        <input
                          *ngIf="item?.parameterTypeBoolean !== 'true'"
                          type="text"
                          [id]="'basic-' + item.parameterName"
                          [formControlName]="item.parameterName"
                          [title]="item.parameterValue"
                        />

                        <!-- Select Dropdown -->
                        <select
                          *ngIf="item?.parameterTypeBoolean === 'true'"
                          [id]="'basic-' + item.parameterName"
                          [formControlName]="item.parameterName"
                        >
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </select>

                        <!-- Tooltip Icon -->
                        <span
                          *ngIf="item.parameterDescription"
                          class="bi bi-info-circle-fill synchpc-primary infoIconConfig"
                          placement="bottom-right"
                          container="body"
                          [ngStyle]="{
                            'margin-left': item?.parameterName.includes(
                              'Password'
                            )
                              ? '0.65rem'
                              : '0.3rem'
                          }"
                          triggers="hover"
                          [ngbTooltip]="syncHpcTooltips"
                        ></span>
                        <ng-template #syncHpcTooltips>
                          <p>{{ item.parameterDescription }}</p>
                        </ng-template>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Right Column -->
          <div class="right">
            <ng-container
              *ngFor="
                let section of getBasicSections();
                let i = index;
                trackBy: trackByParameter
              "
            >
              <div class="section" *ngIf="i >= getBasicSections().length / 2">
                <div class="section-title">
                  <h2 id="basic-right-{{ section[0] | lowercase }}-heading">
                    {{ section[0] }}
                  </h2>
                </div>
                <div class="section-body">
                  <ng-container
                    *ngFor="let item of section[1]; trackBy: trackByParameter"
                  >
                    <div class="body">
                      <label [for]="'basic-right-' + item.parameterName">
                        {{ getDisplayName(item.parameterName) }}
                      </label>

                      <div class="input-container">
                        <input
                          *ngIf="item?.parameterTypeBoolean !== 'true'"
                          type="text"
                          [id]="'basic-right-' + item.parameterName"
                          [formControlName]="item.parameterName"
                          [title]="item.parameterValue"
                        />

                        <select
                          *ngIf="item?.parameterTypeBoolean === 'true'"
                          [id]="'basic-right-' + item.parameterName"
                          [formControlName]="item.parameterName"
                        >
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </select>

                        <span
                          *ngIf="item.parameterDescription"
                          class="bi bi-info-circle-fill synchpc-primary infoIconConfig"
                          placement="bottom-right"
                          container="body"
                          [ngStyle]="{
                            'margin-left': item?.parameterName.includes(
                              'Password'
                            )
                              ? '0.65rem'
                              : '0.3rem'
                          }"
                          triggers="hover"
                          [ngbTooltip]="syncHpcTooltips"
                        ></span>
                        <ng-template #syncHpcTooltips>
                          <p>{{ item.parameterDescription }}</p>
                        </ng-template>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </mat-expansion-panel>

      <!-- Advanced Settings Panel -->
      <mat-expansion-panel
        class="custom-expansion"
        *ngIf="getAdvancedSections().length > 0"
        style="margin-top: 0.5rem"
      >
        <mat-expansion-panel-header
          class="sticky-header border-bottom"
          style="height: 3rem; background-color: white"
        >
          <mat-panel-title style="color: var(--s-primary-color)">
            Advanced Settings
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="expansion-content">
          <!-- Left Column -->
          <div class="left">
            <ng-container
              *ngFor="
                let section of getAdvancedSections();
                let i = index;
                trackBy: trackByParameter
              "
            >
              <div class="section" *ngIf="i < getAdvancedSections().length / 2">
                <div class="section-title">
                  <h2 id="advanced-{{ section[0] | lowercase }}-heading">
                    {{ section[0] }}
                  </h2>
                </div>
                <div class="section-body">
                  <ng-container
                    *ngFor="let item of section[1]; trackBy: trackByParameter"
                  >
                    <div class="body">
                      <label [for]="'advanced-' + item.parameterName">
                        {{ getDisplayName(item.parameterName) }}
                      </label>

                      <div class="input-container">
                        <input
                          *ngIf="item?.parameterTypeBoolean !== 'true'"
                          type="text"
                          [id]="'advanced-' + item.parameterName"
                          [formControlName]="item.parameterName"
                          [title]="item.parameterValue"
                        />

                        <select
                          *ngIf="item?.parameterTypeBoolean === 'true'"
                          [id]="'advanced-' + item.parameterName"
                          [formControlName]="item.parameterName"
                        >
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </select>

                        <span
                          *ngIf="item.parameterDescription"
                          class="bi bi-info-circle-fill synchpc-primary infoIconConfig"
                          placement="bottom-right"
                          container="body"
                          [ngStyle]="{
                            'margin-left': item?.parameterName.includes(
                              'Password'
                            )
                              ? '0.65rem'
                              : '0.3rem'
                          }"
                          triggers="hover"
                          [ngbTooltip]="syncHpcTooltips"
                        ></span>
                        <ng-template #syncHpcTooltips>
                          <p>{{ item.parameterDescription }}</p>
                        </ng-template>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Right Column -->
          <div class="right">
            <ng-container
              *ngFor="
                let section of getAdvancedSections();
                let i = index;
                trackBy: trackByParameter
              "
            >
              <div
                class="section"
                *ngIf="i >= getAdvancedSections().length / 2"
              >
                <div class="section-title">
                  <h2 id="advanced-right-{{ section[0] | lowercase }}-heading">
                    {{ section[0] }}
                  </h2>
                </div>
                <div class="section-body">
                  <ng-container
                    *ngFor="let item of section[1]; trackBy: trackByParameter"
                  >
                    <div class="body">
                      <label [for]="'advanced-right-' + item.parameterName">
                        {{ getDisplayName(item.parameterName) }}
                      </label>

                      <div class="input-container">
                        <input
                          *ngIf="item?.parameterTypeBoolean !== 'true'"
                          type="text"
                          [id]="'advanced-right-' + item.parameterName"
                          [formControlName]="item.parameterName"
                          [title]="item.parameterValue"
                        />

                        <select
                          *ngIf="item?.parameterTypeBoolean === 'true'"
                          [id]="'advanced-right-' + item.parameterName"
                          [formControlName]="item.parameterName"
                        >
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </select>

                        <span
                          *ngIf="item.parameterDescription"
                          class="bi bi-info-circle-fill synchpc-primary infoIconConfig"
                          placement="bottom-right"
                          container="body"
                          [ngStyle]="{
                            'margin-left': item?.parameterName.includes(
                              'Password'
                            )
                              ? '0.65rem'
                              : '0.3rem'
                          }"
                          triggers="hover"
                          [ngbTooltip]="syncHpcTooltips"
                        ></span>
                        <ng-template #syncHpcTooltips>
                          <p>{{ item.parameterDescription }}</p>
                        </ng-template>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </mat-expansion-panel>
    </form>
  </mat-accordion>
</div>
